/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import { transformRequestOptions } from "utils/queryString";
import api from "_config/api";

interface ObterPorteResponse {
  value: number;
  name: string;
}

interface State {
  isRequesting: boolean;
  successPayload: ObterPorteResponse[];
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: [],
  errors: []
};

const obterPorteAnimalSlice = createSlice({
  name: "zoonose@obterPorteAnimal",
  initialState,
  reducers: {
    obterPorteAnimal: (state): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterPorteAnimalSuccess: (
      state,
      action: PayloadAction<ObterPorteResponse[]>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterPorteAnimalFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction() {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/saude/listar-porte`
    );

    const { data } = response;

    yield put(obterPorteAnimalSuccess(data));
  } catch (error) {
    yield put(obterPorteAnimalFailed(formatError(error)));
  }
}

export const {
  obterPorteAnimal,
  obterPorteAnimalSuccess,
  obterPorteAnimalFailed
} = obterPorteAnimalSlice.actions;

export const { reducer } = obterPorteAnimalSlice;

export const saga = takeLatest(obterPorteAnimal.type, sagaFunction);
